// deps
import React, { ReactElement, memo, useContext } from "react";

// internal deps
import { PaymentProgressLoader, PaymentHalfCardLoader, FullPageLoader } from "@swiggy-private/payment-ui";

// constants
import { LOADER_TYPE } from "@payment-client/constants/Loader";
import { PaymentLoaderContext } from "@payment-client/contexts/PaymentLoaderContext";

function PaymentLoader(): ReactElement | null {
    const { loaderData } = useContext(PaymentLoaderContext);

    if (loaderData.type === LOADER_TYPE.HALF_CARD) {
        return <PaymentHalfCardLoader {...loaderData.halfCardLoaderProps} />;
    }
    if (loaderData.type === LOADER_TYPE.FULL_PAGE) {
        return <FullPageLoader />;
    }
    return <PaymentProgressLoader />;
}

export default memo(PaymentLoader);
